module.exports = __webpack_public_path__ + "static/media/reg.70ad3b79.svg";